import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

class PictureComponent extends Component {
  init() {
    this.img = this.element.querySelector('img')
    this.sourceElements = this.element.querySelectorAll('source')

    if (!this.img || !this.sourceElements.length) {
      return
    }

    this.sources = []
    this.sourceElements.forEach(source => this.sources.push({ src: source.srcset, media: source.media || 'screen', style: { objectFit: source.style.objectFit, objectPosition: source.style.objectPosition } }))

    this.addMediaQueryListeners()
    this.applySource(this.sources.find(source => window.matchMedia(source.media).matches))

    if (this.img.currentSrc) {
      this.onImageLoad()
    } else {
      this.img.addEventListener('load', this.onImageLoad.bind(this))
    }
  }

  onImageLoad() {
    this.element.classList.add('picture--loaded')
    this.img.removeEventListener('load', this.onImageLoad.bind(this))
  }

  applySource(source) {
    if (!this.img || !source) {
      return
    }

    if (source.style.objectFit !== undefined) {
      this.img.style.objectFit = source.style.objectFit
    }

    if (source.style.objectPosition !== undefined) {
      this.img.style.objectPosition = source.style.objectPosition
    }
  }

  addMediaQueryListeners() {
    this.sources.forEach(source => window.matchMedia(source.media).addListener(result => result.matches && this.applySource(source)))
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'picture', PictureComponent))
